import { cn, useTheme } from '@kmgestao/ui';

export interface BrandProps {
  /** `mark` = só o monograma (compact). `full` = horizontal com wordmark. */
  variant?: 'mark' | 'full';
  /** Força a variante dark (K branco). Use em fundos escuros onde a variante
   * light (K navy) ficaria com contraste ruim — ex: AuthShell com imagem
   * de fundo + overlay azul. */
  onDark?: boolean;
  className?: string;
}

/**
 * Marca KM Gestão. Consome os SVGs em `apps/web/public/`:
 * - `favicon.svg` — variante `mark` (aba do navegador / topbar compact)
 * - `logo-horizontal.svg` — tema light
 * - `logo-horizontal-dark.svg` — tema dark
 */
export function Brand({ variant = 'full', onDark, className }: BrandProps) {
  const { resolvedTheme } = useTheme();
  const effectiveTheme = onDark ? 'dark' : resolvedTheme;

  if (variant === 'mark') {
    return (
      <img
        src="/favicon.svg"
        alt="KM Gestão"
        width={36}
        height={36}
        className={cn('size-9', className)}
      />
    );
  }

  const src = effectiveTheme === 'dark' ? '/logo-horizontal-dark.svg' : '/logo-horizontal.svg';
  return (
    <img
      src={src}
      alt="KM Gestão — plataforma para clínicas médicas"
      width={250}
      height={80}
      // h-14 = 56px; cabe folgado no header da sidebar/topbar (h-16 = 64px)
      // e ocupa visualmente a maior parte do card. `className` passado pelo
      // shell pode sobrescrever (ex: AuthShell usa tamanho próprio).
      className={cn('h-14 w-auto', className)}
    />
  );
}
